import m from "./atoms-v21144.js";
import f from "./atoms-v21290.js";
import o from "./atoms-v21291.js";
import i from "./atoms-v21145.js";
var u = 6048e5;
function p(t, r) {
  i(1, arguments);
  var e = m(t), a = f(e, r).getTime() - o(e, r).getTime();
  return Math.round(a / u) + 1;
}
export {
  p as default
};
